import { CollabHotelCoverage, CollabValueFields, DefaultLodgingNightsRequired } from "@contracts/collab";

export function isDestinationArranging(hotelNightsCovered: number | null | undefined): boolean {
  return (hotelNightsCovered ?? 0) > 0;
}

export function hasNoLodgingCoverage(hotelCoverageUsed: CollabHotelCoverage | undefined): boolean {
  return hotelCoverageUsed === "NoCoverage";
}

/** Shrpa (or paid add-on) cash lodging stipend when destination covers 0 nights. */
export function usesShrpaLodgingStipend(hotelNightsCovered: number | null | undefined, hotelCoverageUsed: CollabHotelCoverage | undefined): boolean {
  return hotelNightsCovered === 0 && hotelCoverageUsed !== "NoCoverage";
}

export function usesShrpaLodgingStipendFromCollab(collabInput: Pick<CollabValueFields, "hotelNightsCovered" | "hotelCoverageUsed">): boolean {
  return usesShrpaLodgingStipend(collabInput.hotelNightsCovered, collabInput.hotelCoverageUsed);
}

/** Whether this coverage state consumes a paid lodging addon. */
export function consumesLodgingEntitlement(hotelCoverageUsed: CollabHotelCoverage | undefined): boolean {
  return hotelCoverageUsed === "Grandfathered" || hotelCoverageUsed === "PaidAddOn" || hotelCoverageUsed === "CustomerChosePaidAddOn";
}

export function nightsForHotelCoverageUsed(hotelCoverageUsed: CollabHotelCoverage, existingNights: number | null = null): number | null {
  if (hotelCoverageUsed === "CustomerChoseToArrange") {
    return existingNights != null && existingNights > 0 ? existingNights : DefaultLodgingNightsRequired;
  }
  if (hotelCoverageUsed === "NoCoverage" || hotelCoverageUsed === "PaidAddOn" || hotelCoverageUsed === "CustomerChosePaidAddOn" || hotelCoverageUsed === "Grandfathered") {
    return 0;
  }
  return existingNights;
}
